export const packageList = [
  {
    name: 'dsm_flow',
    activeRule: ['dsm-flow']
  },
  {
    name: 'dsm',
    activeRule: ['dsm'],
  }
]

export const remoteModuleConfig = {
  dev: ['dsm_flow', 'dsm'],
  stg: ['dsm_flow', 'dsm'],
  uat: ['dsm_flow', 'dsm'],
  prd: ['dsm_flow', 'dsm'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/dsm/index.js